import { forwardRef, useEffect } from "react";
import { Drawer, Sidenav, Nav } from "rsuite";
import { Exit } from "@rsuite/icons";
import { Link } from "react-router-dom";
import { navLinks } from "../../../config/navLinks";
import { Menu } from "@rsuite/icons";
import styles from "./sideDrawer.module.scss";
import { AuthActions, useAppDispatch } from "../../../core/redux";

type sideDrawerProps = {
  expanded: boolean;
  handleSideNav: () => void;
};

const SideDrawer = ({ expanded, handleSideNav }: sideDrawerProps) => {
  const NavLink = forwardRef<HTMLElement>(
    ({ href, children, ...rest }: any, ref) => (
      <Link ref={ref} to={href} {...rest}>
        {children}
      </Link>
    )
  );

  const dispatch = useAppDispatch();

  const MenuIcon = ({ size }: any) => <Menu style={{ fontSize: size }} />;

  useEffect(() => {
    const drawerWrapper = document.querySelector(".rs-drawer-wrapper");

    drawerWrapper?.addEventListener("click", handleSideNav);

    return () => {
      drawerWrapper?.removeEventListener("click", handleSideNav);
    };
  }, [handleSideNav]);

  return (
    <Drawer
      className={styles.drawer}
      size="xs"
      open={expanded}
      placement="left"
    >
      <Drawer.Body className={styles.drawerBody}>
        <Sidenav className={styles.sideNav}>
          <div className="d-inline-flex align-items-center pb-2">
            <span
              onClick={() => handleSideNav()}
              className={`${styles.toggleIcon} p-3`}
            >
              <MenuIcon size="1.5em" />
            </span>
            <Link to="/home">
              <span
                onClick={() => handleSideNav()}
                className="wtaTitle ps-1 fs-4 text-white"
              >
                WTA Publisher
              </span>
            </Link>
          </div>

          <Nav className={styles.navItems}>
            {navLinks.map((item) => (
              <Nav.Item
                as={NavLink}
                eventKey={item.name}
                key={item.name}
                icon={item.icon}
                href={item.link}
                className={styles.navItem}
                onClick={() => handleSideNav()}
              >
                {item.name}
              </Nav.Item>
            ))}
            <Nav.Item
              onClick={() => dispatch(AuthActions.logout())}
              className={`${styles.navItem} ${styles.lastItem}`}
            >
              <Exit /> Logout
            </Nav.Item>
          </Nav>
        </Sidenav>
      </Drawer.Body>
    </Drawer>
  );
};

export default SideDrawer;
